// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__12so6","home2":"Home_home2__3art_","createAct":"Home_createAct__Vyk4_","inputWrapper":"Home_inputWrapper__1s91a","wrapper":"Home_wrapper__35TM6"};